import React, { useContext } from "react";
import { AppContext } from "../AppContext";
import { makeStyles } from "@material-ui/styles";
import { Box, Paper, Typography, IconButton, LinearProgress } from "@material-ui/core";
import CancelIcon from '@material-ui/icons/Cancel';
import CreateIcon from '@material-ui/icons/Create';
import FilePDFLogo from '../assets/icons/filePDF.svg';
import FileDOCLogo from '../assets/icons/fileDOC.svg';
import FileTXTLogo from '../assets/icons/fileTXT.svg';
import ProjectTag from "./ProjectTag";




export default function FileCard(props) {
  const { id, title, text1, text2, onDelete, projectId, projectName, progressValue, externalProgress, onEdit } = props;
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
      minWidth: 0,
      margin: 0,
      padding: theme.spacing(1),
      transition: "background-color 0.4s",
      boxShadow: "0px 0px 2px 2px rgba(0, 0, 0, 0.2)",
      "&:hover": {
        backgroundColor: '#eeeeee',
        boxShadow: "0px 0px 3px 3px rgba(0, 0, 0, 0.3)",
        transition: "background-color 0.4s",
      },
    },
    nowrap: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    }
  }));
  const classes = useStyles();
  const state = useContext(AppContext);
  const s = state.strings;

  let type = "txt";
  type = (title && title.includes(".doc")) ? "doc" : type;
  type = (title && title.includes(".pdf")) ? "pdf" : type;


  const icons = {
    "pdf": <img src={FilePDFLogo} width={42} alt="pdfLogo" />,
    "doc": <img src={FileDOCLogo} width={42} alt="wordLogo" />,
    "txt": <img src={FileTXTLogo} width={42} alt="textLogo" />
  }

  return (
    <Paper className={classes.root} >
      <div style={{ display: "flex", width: "100%", height: "100%", overflow: "auto", minHeight: 0, flexDirection: "column" }}>
        <div style={{ display: "flex" }}>
          <Typography noWrap variant="body1" style={{ flex: "1 1 auto", width: 0, marginBottom: 5 }}>{title}</Typography>
        </div>
        <div>
          <div style={{ flex: "1 1 auto", minWidth: 0, display: "flex", alignItems: "center" }}>
            <div style={{ flex: "0 0 auto", marginRight: 8 }}>
              {icons[type]}
            </div>
            <div style={{ flex: "1 1 auto", minWidth: 0, display: "flex", flexDirection: "column" }}>
              <Typography variant="body1" color="secondary" noWrap>{text1}</Typography>
              {projectId ?
                <ProjectTag id={projectId} title={projectName} />
                :
                <Typography id={id + "_status"} variant="body1" color="secondary" noWrap>{text2}</Typography>
              }
            </div>
          </div>
        </div>
        {onDelete &&
          <div style={{ flex: "0 0 auto", display: "flex", alignItems: "center" }}>
            <div style={{ flex: "1 1 auto" }}>
              {/* ATTENTION LinearProgress will be replaced by OnUploadProgress() in FileUploadPanel! */}
              {externalProgress ? <div id={id}></div> :
                <LinearProgress variant={typeof (progressValue) == 'number' ? "determinate" : "indeterminate"} value={typeof (progressValue) == 'number' ? progressValue : null} />
              }
            </div>
            <Box style={{ marginLeft: 8 }} />
            {onEdit &&
              <IconButton data-for="globalTT" data-tip={s.newCheck.editTextTip} onClick={(e) => onEdit(e, id)} size="small" disabled={typeof(progressValue) != 'number' || progressValue != 100}>
                <CreateIcon  />
              </IconButton>
            }
            <IconButton data-for="globalTT" data-tip={s.newCheck.removeTextTip} onClick={(e) => onDelete(e, id)} size="small" >
              <CancelIcon />
            </IconButton>
          </div>}
      </div>
    </Paper>
  );
}
